import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleMinus, faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import AdvancedFilter from "./AdvancedFilter";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import { useGetContactFieldsQuery } from "../store/slices/contactsSlice";
import { shortUUID } from "../helpers";

export default function AdvancedFilters({
  filters = [],
  setFilters,
  isRuntimeContacts,
}) {
  const { data: contactFields } = useGetContactFieldsQuery();

  const emptyFilter = {
    values: [],
    valueType: "fixed",
    valueId: "",
    isOr: false,
    fields: ["status"],
    formats: [],
    operator: "is",
    thread: "CurrentThread",
    offsetFrom: "fixed",
    offsetType: "positive",
    offset: "0",
    offsetUnit: "day",
    timeZoneFrom: "fixed",
    timeZone: "",
  };

  return (
    contactFields && (
      <>
        {filters.length > 0 ? (
          filters.map((filter, i) => (
            <div key={filter.uuid} className="d-flex align-items-end mb-3">
              <div className="flex-grow-1">
                <AdvancedFilter
                  isRuntimeContacts={isRuntimeContacts}
                  contactFields={contactFields}
                  filter={filter}
                  setFilter={(fil) =>
                    setFilters(
                      filters
                        .map((f, ii) => {
                          if (i === ii) {
                            return fil;
                          }
                          return f;
                        })
                        .map((f, iii) => ({ ...f, order: iii }))
                    )
                  }
                />
              </div>
              <button
                type="button"
                className="btn btn-link link-danger "
                onClick={() =>
                  setFilters(
                    filters
                      .filter((f) => f !== filter)
                      .map((f, iii) => ({ ...f, order: iii }))
                  )
                }
              >
                <FontAwesomeIcon icon={faCircleMinus} />
              </button>
            </div>
          ))
        ) : (
          <span className=""></span>
        )}
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-colored mb-2"
            onClick={() =>
              setFilters([
                ...filters,
                { ...emptyFilter, order: filters.length, uuid: shortUUID() },
              ])
            }
          >
            <FontAwesomeIcon icon={faCirclePlus} /> Add filter
          </button>
        </div>
        <div>
          <JsonCollapse json={filters} />
        </div>
      </>
    )
  );
}
